<template>
  <div class="update-note-element container-fluid"> 
    <div id="myNav" class="overlay overlay-overall-width-100Perc">
      <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
        <div class="row margin-left-1Point5Perc">
          <div class="col-md-7 col-lg-7 text-align-left margin-Top-1Point5Perc create-element-overlay-course-title-font-styles">
            {{getCurrentlySelectedCourseObj.CourseTitle}}
          </div>    
          <div class="col-md-5 col-lg-5">
            <div class="text-right close-text-font-style margin-right-3Perc cursor-pointer" v-on:click="udpateCloseUpdateElementOverlay($event,false)">
              <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-3Perc float-right" alt="close-icon">
            </div>  
          </div>
        </div>
        <div class="row margin-left-1Point5Perc padding-bottom-1Perc bottom-border margin-bottom-2Perc">
          <div class="col-md-12 col-lg-12 text-align-left font-wight-bold create-element-overlay-module-title-font-styles">
            {{lessonObj.Title}}
          </div>    
        </div>
        <!-- ss: End- Audio-Url Entry ID & Flavour ID  -->
        <div class="row vertical-align margin-bottom-3Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Title
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="NoteTitleValue" :maxlength="maxLength">
              </div>
            </div>
          </div>
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Audio Url
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" v-model="AudioURLValue" :disabled="getCurrentlySelectedCourseObj.Type === 1">
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>  
        </div>
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Duration
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="form-group">
              <div class="col-sm-12">
                <input type="text" class="form-control" placeholder="MM:SS" v-model="NoteDurationValue">
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1"></div>
          <div class="col-md-4 col-lg-4 padding-left-right-30px" v-if="AudioURLValue != null && AudioURLValue != 'null' && AudioURLValue != undefined && AudioURLValue != '' && dmAdminUtils.isValidUrl(AudioURLValue.trim()) && dmAdminUtils.checkForAudioFileExtesion(AudioURLValue.trim())">
            <audio class="audio-width" controls controlsList="nodownload">
              <source :src="AudioURLValue" type="audio/mp3">
            </audio>
          </div>
          <div class="col-md-1 col-lg-1"></div>
        </div>
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-1 col-lg-1">
          </div>  
          <div class="create-lesson-input-text-style col-md-1 col-lg-1 text-align-right padding-right-0Px">
            Content
          </div>
          <div class="col-md-9 col-lg-9">
            <div class="form-group">
              <div class="col-sm-12">
                <tinymce id="d1" v-model="NoteContentValue"></tinymce>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1">
          </div>  
        </div>
        <div class="row vertical-align margin-bottom-2Perc">
          <div class="col-md-12 col-lg-12">
            <div class="form-group">
              <div class="checkbox">
                <label><input type="checkbox" v-model="NoteIncludeInProgress">Include In Progress</label>
              </div>
            </div>
          </div> 
        </div>
        <div class="row margin-bottom-2Perc">
          <div class="col-md-5 col-lg-5">
          </div>  
          <div class="col-md-2 col-lg-2">
            <!-- ToDo: Track this -->
            <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="UpdateNoteElement">Update Note</button>
          </div>  
          <div class="col-md-5 col-lg-5">
          </div>
        </div>
        <div class="row">
        </div>         
      </div>
    </div>
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Show Spinner -->
    <div class="animationload" v-show="showSpinner">
      <div class="osahanloading"></div>
    </div>
    <loader></loader>
  </div> 
</template>
<script>
import { constants } from '@/utils/constants'
import { VueEditor } from 'vue2-quill-editor'
import AlertBox from '@/components/AlertOverlay'
import { elementService } from '@/server-util/element-service'
import Loader from '@/components/dashboard/Loader'
import tinymce from 'vue-tinymce-editor'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
export default {
  props: ['lessonObj', 'ElementObj'],
  name: 'update-note-element',
  created () {
    this.setDefaultValue()
  },
  data: function () {
    return {
      dmAdminUtils: dmAdminUtils,
      constants: constants,
      showAlertDialog: false,
      errorMsg: '',
      includeInProgress: false,
      showSpinner: false,
      elementObj: {
        ElementId: '',
        ModuleId: '',
        Title: '',
        Duration: '',
        Type: 6,
        VideoUrl: '',
        AudioUrl: '',
        Content: '',
        Index: null,
        RDType: 0,
        IncludeInProgress: false,
        LinkText: null,
        FileUrl: null,
        ElemChallenge: null,
        AllowedResponseTypes: ''
      },
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'image', 'video', 'formula', {'color': []}, {'background': []}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'align': []}, 'link'],
        [{'header': [1, 2, 3, 4, 5, 6, false]}, {'font': []}],
        [{'script': 'sub'}, {'script': 'super'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [{ 'direction': 'rtl' }],
        ['clean']
      ],
      allowedResponseTypeArr: [],
      maxLength: constants.Element_Title_Step_Max_Length
    }
  },
  components: {
    'alert-box': AlertBox,
    VueEditor,
    'loader': Loader,
    'tinymce': tinymce
  },
  methods: {
    udpateCloseUpdateElementOverlay: function (event) {
      this.$emit('closeUpdateNoteOverlay', false)
    },
    checkResponseTypeOccurance: function (stringToCheck, originalString) {
      return originalString.indexOf(stringToCheck) !== -1
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    stripHtml: function (html) {
      // Create a new div element
      var temporalDivElement = document.createElement('div')
      // Set the HTML content with the providen
      temporalDivElement.innerHTML = html
      // Retrieve the text property of the element (cross-browser support)
      return temporalDivElement.textContent || temporalDivElement.innerText || ''
    },
    UpdateNoteElement: function (event) {
      // alert(JSON.stringify(this.elementObj))
      if (this.validateRequiredFieldBeforeSubmit()) {
        var _this = this
        var storeObj = this.$store
        if (
          (this.elementObj.ModuleId !== undefined &&
          this.elementObj.ModuleId !== '' &&
          this.elementObj.ModuleId !== undefined) &&
          (this.elementObj.ElementId !== undefined &&
          this.elementObj.ElementId !== '' &&
          this.elementObj.ElementId !== undefined)
        ) {
          // AK: Start showing spinner
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
          const orgContent = dmAdminUtils.removeTFromUrls(_this.elementObj.Content)
          _this.elementObj.AudioUrl = this.elementObj.AudioUrl !== '' ? this.elementObj.AudioUrl.trim() : null
          _this.elementObj.Content = orgContent
          if (parseInt(this.elementObj.RDType) === parseInt(constants.DescVideoType.Teachback)) {
            this.elementObj.AllowedResponseTypes = this.allowedResponseTypeArr.toString()
          } else {
            this.elementObj.AllowedResponseTypes = ''
          }
          elementService
            .updateNoteElement(storeObj.state.access_token, _this.elementObj)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Hide spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                // AK: Hide Update Note Element Overlay
                this.$emit('closeUpdateNoteOverlay', false)
                // AK: Refresh Element List by emitting event
                _this.$emit('refreshElementList', true)
              } else {
                // AK: Hide Spinner
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Selected ModuleId or ElementId is NULL hence declined UPDATE NOTE ELEMENT OPERATION'
          )
        }
      }
    },
    setDefaultValue: function () {
      this.elementObj.ModuleId = this.ElementObj.ModuleId
      this.elementObj.ElementId = this.ElementObj.ElementId
      this.elementObj.Index = this.ElementObj.Index
      this.elementObj.Title = this.ElementObj.Title
      this.elementObj.Duration = this.ElementObj.Duration
      this.elementObj.AudioUrl = this.ElementObj.AudioUrl
      this.elementObj.RDType = this.ElementObj.RDType < 1 ? 0 : this.ElementObj.RDType
      if (this.elementObj.RDType === constants.DescVideoType.Teachback) {
        if (this.ElementObj.AllowedResponseTypes !== null && this.ElementObj.AllowedResponseTypes !== 'null' && this.ElementObj.AllowedResponseTypes !== '' && this.ElementObj.AllowedResponseTypes !== undefined) {
          if (this.checkResponseTypeOccurance('0', this.ElementObj.AllowedResponseTypes)) {
            this.allowedResponseTypeArr.push(0)
          }
          if (this.checkResponseTypeOccurance('1', this.ElementObj.AllowedResponseTypes)) {
            this.allowedResponseTypeArr.push(1)
          }
          if (this.checkResponseTypeOccurance('2', this.ElementObj.AllowedResponseTypes)) {
            this.allowedResponseTypeArr.push(2)
          }
        } else {
          this.allowedResponseTypeArr = [0]
        }
      } else {
        this.allowedResponseTypeArr = []
        this.elementObj.AllowedResponseTypes = ''
      }
      if (parseInt(this.getCurrentlySelectedCourseObj.Type) !== parseInt(constants.CourseType.M365)) {
        this.elementObj.RDType = this.ElementObj.RDType < 1 ? 0 : this.ElementObj.RDType
      } else {
        // AK: Current course is Mentora Moments hence set to Normal by default
        this.elementObj.RDType = parseInt(constants.DescVideoType.Normal)
      }
      this.elementObj.IncludeInProgress = this.ElementObj.IncludeInProgress
      var _this = this
      setTimeout(function () {
        _this.elementObj.Content = dmAdminUtils.updateUrls(_this.ElementObj.Content)
      }, 500)
    },
    validateRequiredFieldBeforeSubmit: function () {
      var regex = /^(?:([0-5]?\d):)?([0-5]?\d)$/g
      if (this.NoteTitleValue.trim().length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Title can\'t be empty.'
        this.elementObj.Title = this.ElementObj.Title
        return false
      } else if (this.AudioURLValue.trim().length !== 0 && (!dmAdminUtils.isValidUrl(this.AudioURLValue.trim()) || !dmAdminUtils.checkForAudioFileExtesion(this.AudioURLValue.trim()))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add valid Audio url.'
        return false
      } else if ((this.NoteDurationValue.trim().length !== 0 && this.NoteDurationValue.indexOf(':') === -1)) {
        this.showAlertDialog = true
        this.errorMsg = 'Duration format should be MM:SS.'
        return false
      } else if (this.elementObj.IncludeInProgress && this.elementObj.Duration.trim().length > 0 && !regex.test(this.elementObj.Duration.trim())) {
        this.showAlertDialog = true
        this.errorMsg = 'Please enter a valid duration.'
        this.elementObj.Duration = this.ElementObj.Duration
        return false
      } else if (this.stripHtml(this.NoteContentValue).length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Content can\'t be empty.'
        this.elementObj.Content = this.ElementObj.Content
        return false
      }
      return true
    }
  },
  computed: {
    getCurrentlySelectedCourseObj: {
      get: function () {
        return this.$store.state.selectedCourseObjFromFilter
      }
    },
    NoteTitleValue: {
      get: function () {
        return this.elementObj.Title
      },
      set: function (newValue) {
        this.elementObj.Title = newValue
      }
    },
    NoteIndexValue: {
      get: function () {
        return this.elementObj.Index
      },
      set: function (newValue) {
        if (newValue.trim() !== '') {
          var isNonNumeric = /[^$,.\d]/
          var nonNumericResult = newValue.match(isNonNumeric)
          if (!nonNumericResult) {
            if (parseInt(newValue) >= 1000) {
              this.errorMsg = 'Index should be less than 1000.'
              this.showAlertDialog = true
              this.elementObj.Index = this.ElementObj.Index
            } else {
              this.elementObj.Index = parseInt(newValue)
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg = 'Index must be a positive numeric value.'
            this.elementObj.Index = this.ElementObj.Index
          }
        } else {
          this.elementObj.Index = null
        }
      }
    },
    NoteDurationValue: {
      get: function () {
        return this.elementObj.Duration
      },
      set: function (newValue) {
        this.elementObj.Duration = newValue
      }
    },
    NoteContentValue: {
      get: function () {
        return this.elementObj.Content
      },
      set: function (newValue) {
        this.elementObj.Content = newValue
      }
    },
    NoteIncludeInProgress: {
      get: function () {
        return this.elementObj.IncludeInProgress
      },
      set: function (newValue) {
        this.elementObj.IncludeInProgress = newValue
      }
    },
    AudioURLValue: {
      get: function () {
        return this.elementObj.AudioUrl
      },
      set: function (newValue) {
        this.elementObj.AudioUrl = newValue
      }
    },
    DescVideoType: {
      get: function () {
        return this.elementObj.RDType
      },
      set: function (newValue) {
        this.elementObj.RDType = parseInt(newValue)
        if (parseInt(newValue) === constants.DescVideoType.Normal) {
          this.allowedResponseTypeArr = []
        }
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.margin-left-1Point5Perc
{
  margin-left:1.5%;
}
.border-red {
  border: 1px solid red;
}
.create-lesson-label-text-style {
  color: #34495e;
  font-size: 12px;
}
.audio-width {
  width: -webkit-fill-available;
}
.padding-left-right-30px {
  padding-left:30px;
  padding-right: 30px;
}
.margin-left-0px {
  margin-left:0px;
}
.margin-bottom-3Perc {
  margin-bottom:3%;
}
</style>


// WEBPACK FOOTER //
// src/components/UpdateNoteElement.vue